import * as React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import themePrimary from '../../styles/themePrimary'
import RestaurantLogo from '../common/RestaurantLogo';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { Skin } from '../../models/common/Skin';

const useStyles = makeStyles({
    appBar: {
        zIndex: themePrimary.zIndex.drawer + 1,
        boxShadow: 'none',
        borderBottom: '1px solid ' + themePrimary.palette.secondary.dark,
        backgroundColor: themePrimary.palette.primary.contrastText,
        height: ElementDimensions.appBarHeight + 'px',
    },
    imgLogo: {
        maxHeight: ElementDimensions.logoHeight + 'px',
    },
    logoContainer: {
        marginLeft: 'auto',
        marginRight: 'auto',
    },
    root: {
        //display: 'flex',
    },
    logoText: {
        fontSize: '1.1em',
        color: themePrimary.palette.secondary.contrastText,
        lineHeight: '1em',
        letterSpacing: '2px',
    },
    logoTextSub: {
        fontSize: '.6em',
        color: themePrimary.palette.secondary.contrastText,
    },
    logoTextContainer: {
        marginTop: ElementDimensions.margin20 + 'px',
        marginLeft: '-4px',
        textAlign: 'center',
    },
    toolBarCustomSkin: {
        zIndex: themePrimary.zIndex.drawer + 1,
        boxShadow: 'none',
        backgroundColor: props => (props as Skin).appBar_background_color,
        height: ElementDimensions.appBarHeight + 'px',
    },
    toolBar: {
        zIndex: themePrimary.zIndex.drawer + 1,
        boxShadow: 'none',        
        backgroundColor: props => (props as Skin).appBar_background_color,
        height: '0px',
    },
    toolBarBorder: {
        borderBottom: '1px solid ' + themePrimary.palette.grey[400],
    },
});

export default function MainAppBar() {
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color,
        appBar_background_color: checkOutState.state.skin.appBar_background_color });

    return (
        <div className={classes.root}>
            <Toolbar className={clsx({
                [classes.toolBarCustomSkin]: checkOutState.state.skin.use_custom_skin,
                [classes.toolBar]: !checkOutState.state.skin.use_custom_skin,
                [classes.toolBarBorder]: checkOutState.state.skin.appBar_background_color === '#ffffff',
            })}>
                <RestaurantLogo />
            </Toolbar>
        </div>
    );
}
